import { Button } from "semantic-ui-react";
import AccordionGroup, { IAccordionConfig } from "Views/Components/Accordion/Accordion";
import CustomerApplicationDetail from "../CustomerApplicationDetail";

export function CustomerApplicationBusinessInfoTab(props: {
	businessName: string
}) {

	const accordions: IAccordionConfig[] = [
		{
			key: 'section1',
			title: 'Basic Information',
			component: <p>This is the content of section 1.</p>,
		},
		{
			key: 'section2',
			title: 'Abr Information',
			component: (
				<div>
					<h4>Details for section 2</h4>
					<ul>
						<li>Point A</li>
						<li>Point B</li>
					</ul>
				</div>
			),
		},
		{
			key: 'section3',
			title: 'Asic information',
			component: <p>This is the content of section</p>,
		},
		{
			key: 'section4',
			title: 'Line of Business - Trading Style and SIC Codes',
			component: <p>This is the content of section</p>,
		},
		{
			key: 'section5',
			title: 'Director information',
			component: <p>This is the content of section</p>,
		},
		{
			key: 'section6',
			title: 'Liquor information',
			component: <p>This is the content of section</p>,
		},
	];


	return (
		<CustomerApplicationDetail>
			<CustomerApplicationDetail.Title title="Business information"/>
			<AccordionGroup accordions={accordions} />
		</CustomerApplicationDetail>
	)
}
